export default "__VITE_ASSET__CGquhNsF__"